import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from '../../api/api';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';

const LOG_URL = '/api/v2/login';

const Login = ({ setAccessToken }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const token = await axios.post(LOG_URL,
        JSON.stringify({ email, password }),
        {
          headers: { 'Content-Type': 'application/json' },
          withCredentials: true
        }
      );
      setAccessToken(token);
      toast.success('Login Successful');
      navigate('/admin/admin-home');
    } catch (error) {
      if (!error?.response) {
        toast.error('No Server Response');
      } else if (error.response?.status === 400) {
        toast.error('Username and password are required');
      } else if (error.response?.status === 401) {
        toast.error('Invalid email');
      } else if (error.response?.status === 402) {
        toast.error('Invalid password');
      } else {
        toast.error('Login Failed');
      }
      console.log(error.response)
      console.log(error);
    }
  };

  return (
    <main>
      <div className='bg-[#B1B2FF]'>
        <div className='mx-auto p-4 lg:container'>
          <div className='flex items-center justify-center h-screen'>
            <div className='p-6 bg-white text-center rounded-md lg:w-1/3'>
              <h3 className='text-xl'>Admin Login</h3>
              <p className='py-2'>Only admins can pass beyond this point.</p>
              <form onSubmit={handleSubmit}>
                <label htmlFor='Email'>
                  <input
                    type='email'
                    placeholder='Email Address'
                    className='mt-4 px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block w-full rounded-md sm:text-sm focus:ring-1'
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </label>
                <label htmlFor='Password'>
                  <input
                    type='password'
                    required
                    placeholder='Password'
                    className='mt-2 px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block w-full rounded-md sm:text-sm focus:ring-1'
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </label>
                <button type='submit' className='px-6 py-2 mt-3 bg-blue-600 text-white rounded-lg'>Login</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Login;

Login.propTypes = {
  setAccessToken: PropTypes.func
};
